import Modal, { ModalProps } from 'react-bootstrap/Modal';
import { FormFieldVisibility } from '../../app/components/FormLabel';
import { VisibilityIcon } from '../../app/components/VisibilityIcon';

export const VisibilityModal = (props: ModalProps) => {
  return (
    <Modal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>About the information you provide</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          We will never sell your personal information. You can check out our Privacy Policy to
          learn more.
        </p>
        <p>During this setup you will find three different icons:</p>
        <dl>
          <dt>
            <VisibilityIcon visibility={FormFieldVisibility.PUBLIC} /> Visible to everyone
          </dt>
          <dd>
            Fields that are visible to healthcare organizations regardless of connection status
          </dd>
          <dt>
            <VisibilityIcon visibility={FormFieldVisibility.CONNECTED} /> Visible to Sendit staff
            and facilities you connect with
          </dt>
          <dd>
            Fields that are visible only to healthcare organizations that you have connected with
          </dd>
          <dt>
            <VisibilityIcon visibility={FormFieldVisibility.PRIVATE} /> Visible only to you and
            Sendit
          </dt>
          <dd>Fields that are visible only to Sendit staff members and yourself</dd>
        </dl>
      </Modal.Body>
    </Modal>
  );
};
